import { useEffect, useState } from 'react';
/**
 * CZNA-538 — how long a query may run before we say so in words.
 *
 * Below this the extra line is noise; above it a silent indicator starts to read as
 * a freeze. Five seconds is chosen against the queries this module actually runs:
 * a filtered type list settles well under it, a lookup by identifier over the 1.27M
 * corpus does not.
 */
export var SLOW_QUERY_MS = 5000;
/**
 * True once `active` has been continuously true for `delayMs`.
 *
 * Resets on every falling edge of `active`, so two fast queries in a row never add
 * up to a slow one. Callers use it to escalate the wording, never to change what is
 * displayed structurally — the indicator itself must be present from the first frame.
 */
export var useSlowQueryNotice = function (active, delayMs) {
    if (delayMs === void 0) { delayMs = SLOW_QUERY_MS; }
    var _a = useState(false), isSlow = _a[0], setIsSlow = _a[1];
    useEffect(function () {
        if (!active) {
            setIsSlow(false);
            return undefined;
        }
        var timer = setTimeout(function () { return setIsSlow(true); }, delayMs);
        return function () { return clearTimeout(timer); };
    }, [active, delayMs]);
    return isSlow;
};
export default useSlowQueryNotice;
